import { atom, useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { localStorageEffect } from './effects';

const key = 'accountId2';

export const accountId = atom<string>({
    key,
    default: undefined,
    effects: [
        localStorageEffect(key)
    ]
});

export const useSetAccountId = () => useSetRecoilState(accountId);
export const useAccountId = () => useRecoilValue(accountId);
export const useAccountIdState = () => useRecoilState(accountId);